// extracted by mini-css-extract-plugin
module.exports = {"selectWrap":"style-module--select-wrap--2EJcK"};